import { render, staticRenderFns } from "./roleBasedHeader.vue?vue&type=template&id=07f50229"
import script from "./roleBasedHeader.vue?vue&type=script&lang=js"
export * from "./roleBasedHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports